import { render, staticRenderFns } from "./verify-2fa.vue?vue&type=template&id=51340310&scoped=true&lang=pug&"
import script from "./verify-2fa.vue?vue&type=script&lang=js&"
export * from "./verify-2fa.vue?vue&type=script&lang=js&"
import style0 from "./verify-2fa.vue?vue&type=style&index=0&id=51340310&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51340310",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VImg,VOtpInput,VRow})
